import parseJwt from './parseJwt';

export const extractToken = () => {
    const accessToken = localStorage.getItem('accessToken');
    if (!accessToken) return {};
    return parseJwt(accessToken);
  };
  
  export const isLogin =() => {
      const user = extractToken();
      if(user.sub) return true;
      else return false;
  }